$(document).ready(function() {
 const delivery_timer = setInterval(deliverytimer, 1000);
  function deliverytimer() {
    var subscription_html = $(".skio-plan-picker").html();
      var selected_value = $(".skio-group-container input:checked").parents(".skio-group-container").find("select.skio-frequency").html();
        $(".delivery_select_wrapper select.delivery_dropdown").html(selected_value);
          if(typeof subscription_html !== 'undefined'){
              $(".delivery_select_wrapper").show();
          }
           clearInterval(delivery_timer);
          }
  
        $(document).on("change",".qty_deleviry_data_wrapp .delivery_select_wrapper select", function() {
        var data_change = $(this).val(); 
        var sortBySelect = document.querySelector(".skio-group-container--selected select.skio-frequency"); 
        sortBySelect.value = data_change; 
        sortBySelect.dispatchEvent(new Event("change"));
        });
       $(".DeliveryHead").html("Deliver Every");
       $(document).on("change",".skio-group-container input.skio-group-input", function() {
        var get_value = $(this).val();
         if(get_value !== ''){
          var selected_value = $(this).parents(".skio-group-container").find("select.skio-frequency").html();
          $(".delivery_select_wrapper select.delivery_dropdown").html(selected_value);
          $(".DeliveryHead").html("Deliver Every");
          $(".delivery_select_wrapper").show();
       }else{
         $(".DeliveryHead").html("");
            $(".delivery_select_wrapper").hide();
       }
    });

    $(".qty_deleviry_data_wrapp .heading_select_wrapp select").change(function() {
       var data_change = $(this).val(); 
        $(".price-per-item__container quantity-input.quantity input").val(data_change);
    });
     $(document).on("click",".FaqMain_details", function(e) {
      e.preventDefault();
        $(this).toggleClass('active-acc-icon');
          $('.FaqMain_details').not($(this)).removeClass('active-acc-icon');
            $(this).parents('.Faq_details').find('.faq_description').slideToggle();
              $('.faq_description').not($(this).parents('.Faq_details').find('.faq_description')).slideUp();
    });

 
    $(document).on('click','.pdpTabs_Text',function(){
      $(this).addClass('Activetab').siblings().removeClass('Activetab');        
    });
    $(document).on("change",".inner_all_grid_rpeater .skio-group-container input.skio-group-input", function() {
      var data_value = $(this).parents('.skio-group-container').find(".skio-frequency select option:selected").val();
        $(this).parents('.inner_all_grid_rpeater').find('.colection_page_selling').val(data_value);
     });
    var managepoints= $('.CustomMange').html();
     var getonetime2 =  $('.skio-plan-picker .skio-group-container input.skio-group-input:checked').attr('skio-one-time');
     $("<div class='MainContent_Wraper' style='display:none;'><div class='SelectedPoints'>"+managepoints+" </div>").insertAfter(".skio-group-label");
       if( typeof getonetime2 == 'undefined' ){
         $(".skio-group-container input:checked").parents(".skio-group-container").find(".MainContent_Wraper").show();
       } else{
         $(".skio-group-container input:checked").parents(".skio-group-container").find(".MainContent_Wraper").hide();
      }    


      $(document).on('change','.skio-plan-picker .skio-group-container input.skio-group-input',function(){
        var getonetime =  $(this).attr('skio-one-time');
         $(".skio-plan-picker .skio-group-container .MainContent_Wraper").hide(); 
           if( typeof getonetime == 'undefined' ){
             $(this).parents(".skio-plan-picker .skio-group-container").find(".MainContent_Wraper").show();
           }
          else{
            $(".skio-plan-picker .skio-group-container .MainContent_Wraper").hide(); 
          }    
      });

      $('.skio-group-container').each(function(){
          var tab_html = '';
          var loadvaalu = $(this).find('.skio-group-content select option:selected').val() ;
            $(this).find('.skio-group-content select option').each(function(index) {
              var data_val = $(this).html();
              var getdisable  = $(this).attr('disabled');            
              var data_vals = $(this).val();
              var trimed_val = $.trim(data_val);
              var seperatetext = trimed_val.split('Delivery')[1];
                if(getdisable != 'disabled'){
                  if( typeof seperatetext !== "undefined"){
                     if(loadvaalu == data_vals){
                       tab_html+='<div class="AllOprions Active_option" data_id="'+data_vals+'">'+seperatetext+'</div>';
                     }else{
                       tab_html+='<div class="AllOprions" data_id="'+data_vals+'">'+seperatetext+'</div>';
                     }
                    }else{
                     if(loadvaalu == data_vals){
                       tab_html+='<div class="AllOprions Active_option" data_id="'+data_vals+'">'+trimed_val+'</div>';
                     }else{
                       tab_html+='<div class="AllOprions" data_id="'+data_vals+'">'+trimed_val+'</div>';
                     }
                  }
              }
          });
            if(tab_html != ''){
               $("<div class='CustomSubOptions'> <div class='SubHeading'>Delivery every:</div> <div class='Alloptions '>"+tab_html+"  </div> </div></div>").insertBefore($(this).find('.SelectedPoints'));
            }
          });

        
        window.addEventListener("variant:change",(e)=>{
          $('.CustomSubOptions').remove();
        $('.skio-group-container').each(function(){
            var tab_html = '';
          var loadvaalu = $(this).find('.skio-group-content select option:selected').val() ;
            $(this).find('.skio-group-content select option').each(function(index) {
        var data_val = $(this).html();
            var getdisable  = $(this).attr('disabled');
              console.log(getdisable);
              var data_vals = $(this).val();
                var trimed_val = $.trim(data_val);
              var seperatetext = trimed_val.split('Delivery')[1];
              if(getdisable != 'disabled'){
                if( typeof seperatetext !== "undefined"){
               if(loadvaalu == data_vals){
               tab_html+='<div class="AllOprions Active_option" data_id="'+data_vals+'">'+seperatetext+'</div>';
             }else{
               tab_html+='<div class="AllOprions" data_id="'+data_vals+'">'+seperatetext+'</div>';
             }
        }else{
                 if(loadvaalu == data_vals){
               tab_html+='<div class="AllOprions Active_option" data_id="'+data_vals+'">'+trimed_val+'</div>';
             }else{
               tab_html+='<div class="AllOprions" data_id="'+data_vals+'">'+trimed_val+'</div>';
             }
        }
              }
        
        });
            if(tab_html != ''){
           $("<div class='CustomSubOptions'> <div class='SubHeading'>Delivery every:</div> <div class='Alloptions '>"+tab_html+"  </div> </div></div>").insertBefore($(this).find('.SelectedPoints'));
            }
        });
        });
  
        $(document).on('click','.AllOprions',function(){
          $(this).addClass('Active_option').siblings().removeClass('Active_option');
        var data_change = $(this).attr('data_id'); 
          var sortBySelect = document.querySelector(".skio-group-container--selected select.skio-frequency"); 
          sortBySelect.value = data_change; 
          sortBySelect.dispatchEvent(new Event("change"));  
      });


      // product page on click scroll
      
     $(".pdp_Wrapper .pdpTabs_Text").click(function() {
            var clickedHtml = $(this).attr('dada-handle');
           $('html, body').animate({
            'scrollTop' : $(".Gethandle[data-handle='"+clickedHtml+"']").offset().top
        },2000);
        });



// Header hide when we on footer  

  $.fn.isOnScreen = function(){
    
    var win = $(window);
    
    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();
    
    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth() + 300;
    bounds.bottom = bounds.top + this.outerHeight() + 300;
    
    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
    
    };
    if($('.CustomFooterChange').isOnScreen() == true){
    $("sticky-header.header-wrapper.customHeader.color-background-1.gradient.header-wrapper--border-bottom").hide();
    }else{
    $("sticky-header.header-wrapper.customHeader.color-background-1.gradient.header-wrapper--border-bottom").show();
    }
    $(window).scroll(function(){
    if($('.CustomFooterChange').isOnScreen() == true){
    $("sticky-header.header-wrapper.customHeader.color-background-1.gradient.header-wrapper--border-bottom").hide();
    }else{
    $("sticky-header.header-wrapper.customHeader.color-background-1.gradient.header-wrapper--border-bottom").show();
    }
    });
      
 
  $(document).on('click', '.CustomInner_variant input', function() {
    $(this).parents('.CustomForm').children('.CustomProduct_Variants').siblings().removeClass('active');

    $(this).parents('.CustomProduct_Variants').toggleClass('active');
  });

 $ (document).on('click', '.pdpnutrition',function(){
     $('.PopupIngredient h2').hide();
   $('.Pop_UpBox img').show();
  var pdpnut = $(this).attr('data-product-image');  
     $('.Pop_UpBox img').attr('src', pdpnut);
      $('.CustomPop_up').addClass('PopUp_Active');
     $('body').addClass('Open_popup');
  });
  $(document).on('click','.pdpingredient', function(){
       $('.PopupIngredient h2').show();
     $('.Pop_UpBox img').hide();
     var getpdping = $(this).attr('data-product-ingredient');
      $('.PopupIngredient h2').html(getpdping);
     $('.CustomPop_up').addClass('PopUp_Active');
       $('body').addClass('Open_popup');
  })

  $('.skio-group-container').each(function(){
    var $saveElement = $(this).find('span.skio-save');
    var saveContent = $saveElement.html();  
    if (saveContent) { 
      var saveContentWithParentheses = '(' + saveContent + ')';  
      $saveElement.insertAfter($(this).find('.skio-price span')).html(saveContentWithParentheses);
    }
  });


    $(document).on("click",".AccFaq_Heading", function(e) {
    e.preventDefault();
    $(this).toggleClass('active-acc-pro');
    $('.AccFaq_Heading').not($(this)).removeClass('active-acc-pro');
    $(this).parents('.MainAcrodion ').find('.Acc_Content').slideToggle();
    $('.Acc_Content').not($(this).parents('.MainAcrodion ').find('.Acc_Content')).slideUp();
  });
  
});


